import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_app_download.png';

const _withScopeId = n => (_pushScopeId("data-v-46e714de"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "side-bar"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  style: {
    "height": "30px",
    "width": "30px"
  }
}, null, -1));

const _hoisted_3 = {
  key: 0,
  class: "item__menu-title"
};
import Menu from '@/views/layout/Menu/index.vue';
import { menuList } from '@/router/routes';
import { useRoute } from 'vue-router';
import { useCommon } from '@/store/useCommon';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const route = useRoute();
    const storeCommon = useCommon(); // 菜单是否折叠

    const isCollapse = computed(() => storeCommon.isCollapse);

    const onAppDownloadClick = () => {
      window?.microApp.dispatch({
        type: 'onAppDownloadClick'
      });
    };

    const handleOpen = (key, keyPath) => {// console.log(key, keyPath)
    };

    const handleClose = (key, keyPath) => {// console.log(key, keyPath)
    };

    const activeMenu = computed(() => {
      const {
        meta,
        path
      } = route; // if set path, the sidebar will highlight the path you set

      if (meta.activeMenu) {
        return meta.activeMenu;
      }

      return path;
    });
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          style: {
            "height": "100%"
          },
          "default-active": _unref(activeMenu),
          class: "el-menu-vertical-demo",
          onOpen: handleOpen,
          onClose: handleClose,
          "background-color": "#36373A",
          "text-color": "#fff",
          "collapse-transition": false,
          "menu-trigger": "click",
          collapse: _unref(isCollapse),
          router: ""
        }, {
          default: _withCtx(() => [_createVNode(Menu, {
            "menu-list": _unref(menuList)
          }, null, 8, ["menu-list"])]),
          _: 1
        }, 8, ["default-active", "collapse"]), _createElementVNode("div", {
          style: {
            "width": "100%"
          },
          class: "el-sub-menu__title app-qr-menu",
          onClick: onAppDownloadClick
        }, [_hoisted_2, !_unref(isCollapse) ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('APP Download')), 1)) : _createCommentVNode("", true)])]),
        _: 1
      })]);
    };
  }

});